import {EntityModel} from "@fedeltapointofsale/data-client";
import {InventoryGroupData} from "./inventory-group.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class InventoryGroupEntityModel extends EntityModel<InventoryGroupData> {

    constructor(injector: Injector) {
        super(injector, InventoryGroupData);
    }
}
